import { lazy, Suspense } from 'react';
import { Card } from '@bid/shared-ui';

const MissionGenerator = lazy(() => import('missionGenerator/MissionGenerator'));

export const MissionGeneratorPage = (): JSX.Element => {
  return (
    <div data-testid="mission-generator-page">
      <Suspense
        fallback={
          <Card title="Loading Mission Generator...">
            <div className="flex items-center justify-center p-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-bitd-gold"></div>
            </div>
          </Card>
        }
      >
        <MissionGenerator />
      </Suspense>
    </div>
  );
};
